const TOURNAMENT_TYPES_WITH_STANDINGS: TournamentType[] = [
  'double_round_robin',
  'single_round_robin'
];

export { TOURNAMENT_TYPES_WITH_STANDINGS };
